import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { v4 as uuidv4 } from 'uuid';
import './Faq.css';

export const FaqSection = ({ sectionTitle, questions }) => {
  return (
    <div className="sectionContainer">
      <Accordion id="sectionFaq" elevation={0} defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className="icon" />}
          aria-controls="panel1-content"
        >
          <h3 className="sectionTitle">{sectionTitle}</h3>
        </AccordionSummary>

        <AccordionDetails className="sectionDetails">
          {questions.map((item, index) => (
            <Accordion key={uuidv4()} id="sectionItem" defaultExpanded={index == 0}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="section" />}
                aria-controls={`panel${index}-content`}
              >
                <Typography component="span" className="sectionQuestion">
                  {item.question}
                </Typography>
              </AccordionSummary>

              <AccordionDetails className="sectionAnswer" id={`answer${index}`}>
                <div className="sectionAnswerP">{item.answer}</div>
              </AccordionDetails>
            </Accordion>
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
